function detroitClock(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Detroit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  const read = (type) => parts.find((part) => part.type === type)?.value;
  return {
    hour: read('hour'),
    minute: read('minute'),
    second: read('second'),
  };
}

function hasClockTime(value) {
  if (value == null || value === '') return false;
  const text = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return false;
  const naive = text.match(
    /^\d{4}-\d{2}-\d{2}[ T](\d{2}):(\d{2})(?::(\d{2}))?$/,
  );
  if (naive) {
    return naive[1] !== '00' || naive[2] !== '00' || (naive[3] || '00') !== '00';
  }
  const clock = detroitClock(text);
  if (!clock) return false;
  return clock.hour !== '00' || clock.minute !== '00' || clock.second !== '00';
}

function workOrderCardDate(order) {
  if (!order) return '';
  if (hasClockTime(order.sent_datetime)) return order.sent_datetime;
  return order.date || '';
}

module.exports = { workOrderCardDate };
